<template>
	<VDropdown v-if="isFavoriteViewActive"
	           :delay="{ hide: 2000 }"
	           :hideTriggers="(triggers: any) => [...triggers, 'focus', 'hover']"
	           class="copy-link-btn"
	           distance="20"
	           placement="top">

		<button class="catalog-overview-header__favorites"
		        type="button"
		        @click="copyUrl">

			<svg class="icon" height="30" width="30">
				<use href="/assets/images/build/svg-sprite.catalog.min.svg#share"></use>
			</svg>
		</button>

		<template #popper>
			<div class="tooltip">
				{{ $t('site.products.overview.header.availability.copyLink.button.text') }}
			</div>
		</template>
	</VDropdown>
</template>

<script lang="ts" setup>

	import {useFavoriteProductStore} from '@/store/favorite.product.store';
	import {computed} from 'vue';

	const favoriteStore = useFavoriteProductStore();

	const isFavoriteViewActive = computed(() => favoriteStore.favoriteViewActive);

	const copyUrl = () => {
		const url = window.location.href;
		const favorites = favoriteStore.getFavoritesAsQueryParams();
		navigator.clipboard.writeText(url + favorites);
	};

</script>

<style lang="scss" scoped>
	@import "../../../../../webapp/template/assets/css/source/settings";

	.copy-link-btn {
		display: inline-block;
		padding-right: 5px;
		margin-left: 0.5em
	}

	.tooltip {
		line-height: 18px;
		padding: 6px 14px;
		color: $color-heritage-gray;
	}
</style>
